import React from 'react';
import PropTypes from 'prop-types';
import {HintBlock} from '../HintBlock';
import {Image} from '@learningblocks/storybook-components';
import bottomBg from '@learningblocks/exp-constants/lib/Images/heatblock-Background.svg';
import shadow from '@learningblocks/exp-constants/lib/Images/heatblockShadow.svg';
import {SetTemperature} from './SetTemperature';
import style from './style.module.scss';
import {CurrentTemperature} from './CurrentTemperature';
import {Button} from './Buttons';
import {TemperatureLabel} from './TemperatureLabels';
import {HeatBlockImage} from './HeatBlockImage';
import {Instruction} from './Instruction';
import {Heading} from './Heading';

export function ContentBlock(props) {
  return (
    <>
      <div
        tabIndex={0}
        className={`${style.heatBlockContent} ${props.className} `}>
        <div className={style.heatBlockContent_leftSide}>
          <Heading />
          <Instruction />
          <HintBlock balance={props.balance} />
        </div>
        <div className={style.heatBlockContent_rightSide}>
          <TemperatureLabel />
          <SetTemperature
            temperature={props.temperature}
            setTemperature={props.setTemperature}
          />
          <CurrentTemperature
            currentTemp={props.currentTemp}
            balance={props.balance}
          />
          <Button
            setTemperature={props.setTemperature}
            temperature={props.temperature}
          />
          <HeatBlockImage slots={props.slots} />
        </div>
        <Image
          src={bottomBg}
          className={style.heatBlockContent_imageBackground}
        />
        <Image
          src={shadow}
          className={style.heatBlockContent_backgroundShadow}
        />
      </div>
    </>
  );
}

ContentBlock.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
  /**
   * Slots are the array which represent the filing of tube
   */
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * It defines the number of slot in the heatblock
       */
      slotId: PropTypes.number.isRequired,
      /**
       * It defines the number of slot in the heatblock
       */
      tube: PropTypes.bool,
    })
  ).isRequired,
  /**
   * State to store the setTemperature value
   */
  temperature: PropTypes.number,
  /**
   * Set temperature is a function to change the set Temperature
   */
  setTemperature: PropTypes.func,
  /**
   * State to store the currentTemp value
   */
  currentTemp: PropTypes.number,
  /**
   * It denotes the current temperature and the setTemperature is equal or not
   */
  balance: PropTypes.bool,
};

ContentBlock.defaultProps = {};
